
				var addMethods = require("../../../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["searchInDocWorker","multipleSearchInDocWorker","getPreviousFewWords","searchContinuousSilence","searchSmartEditAppliedSilence"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "c3502be77c942f20e79a.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			